import type { CarouselItem } from '../types';
import { placeholderImages } from '../utils/placeholders';

// Datos de ejemplo para editoriales
export const editorialesData: CarouselItem[] = [
  {
    id: 'mental-breakdown',
    title: 'MENTAL BREAKDOWN',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['mental-breakdown'],
    linkUrl: '/proyectos/editoriales/mental-breakdown',
    year: '2024',
    description: 'Editorial conceptual de alta intensidad'
  },
  {
    id: 'xtrema-studio',
    title: 'XTREMA STUDIO',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['xtrema-studio'],
    linkUrl: '/proyectos/editoriales/xtrema-studio',
    year: '2024',
    description: 'Sesión de estudio vanguardista'
  },
  {
    id: 'rouge',
    title: 'ROUGE',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['rouge'],
    linkUrl: '/proyectos/editoriales/rouge',
    year: '2024',
    description: 'Editorial en tonos rojos vibrantes'
  },
  {
    id: 'demeo',
    title: 'DEMEO',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['demeo'],
    linkUrl: '/proyectos/editoriales/demeo',
    year: '2024',
    description: 'Editorial moderno y minimalista'
  },
  {
    id: 'bodegon',
    title: 'BODEGÓN',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['bodegon'],
    linkUrl: '/proyectos/editoriales/bodegon',
    year: '2024',
    description: 'Editorial de moda conceptual con naturaleza muerta'
  },
  {
    id: 'boudoir',
    title: 'BOUDOIR',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['boudoir'],
    linkUrl: '/proyectos/editoriales/boudoir',
    year: '2024',
    description: 'Sesión íntima y elegante'
  },
  {
    id: 'cold-memories',
    title: 'COLD MEMORIES',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['cold-memories'],
    linkUrl: '/proyectos/editoriales/cold-memories',
    year: '2023',
    description: 'Editorial melancólico de invierno'
  },
  {
    id: 'dysmorphia',
    title: 'DYSMORPHIA',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['dysmorphia'],
    linkUrl: '/proyectos/editoriales/dysmorphia',
    year: '2024',
    description: 'Exploración conceptual de la percepción'
  },
  {
    id: 'gentleman',
    title: 'GENTLEMAN',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['gentleman'],
    linkUrl: '/proyectos/editoriales/gentleman',
    year: '2024',
    description: 'Estilismo masculino elegante'
  },
  {
    id: 'gravity',
    title: 'GRAVITY',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['gravity'],
    linkUrl: '/proyectos/editoriales/gravity',
    year: '2024',
    description: 'Concepto de levedad y peso'
  },
  {
    id: 'jaque-al-rey',
    title: 'JAQUE AL REY',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['jaque-al-rey'],
    linkUrl: '/proyectos/editoriales/jaque-al-rey',
    year: '2024',
    description: 'Editorial estratégico de moda'
  },
  {
    id: 'lagrima-santa',
    title: 'LÁGRIMA SANTA',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['lagrima-santa'],
    linkUrl: '/proyectos/editoriales/lagrima-santa',
    year: '2024',
    description: 'Editorial de moda conceptual'
  },
  {
    id: 'street-edition',
    title: 'STREET EDITION',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['street-edition'],
    linkUrl: '/proyectos/editoriales/street-edition',
    year: '2024',
    description: 'Moda urbana contemporánea'
  },
  {
    id: 'susurros-de-algodon',
    title: 'SUSURROS DE ALGODÓN',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['susurros-algodon'],
    linkUrl: '/proyectos/editoriales/susurros-de-algodon',
    year: '2024',
    description: 'Editorial suave y minimalista'
  },
  {
    id: 'whispers-of-the-twenties',
    title: 'WHISPERS OF THE TWENTIES',
    category: 'editoriales',
    imageUrl: placeholderImages.editoriales['whispers-twenties'],
    linkUrl: '/proyectos/editoriales/whispers-of-the-twenties',
    year: '2023',
    description: 'Inspiración vintage años 20'
  }
];

// Datos de ejemplo para publi
export const publiData: CarouselItem[] = [
  {
    id: 'fanta',
    title: 'FANTA',
    category: 'publi',
    imageUrl: placeholderImages.publi['fanta'],
    linkUrl: '/proyectos/publi/fanta',
    // isVideo: false, // ELIMINADO: Video support removed temporarily
    year: '2024',
    description: 'Campaña publicitaria refrescante'
  },
  {
    id: 'oscar-mayer',
    title: 'OSCAR MAYER',
    category: 'publi',
    imageUrl: placeholderImages.publi['oscar-mayer'],
    linkUrl: '/proyectos/publi/oscar-mayer',
    // isVideo: false, // ELIMINADO: Video support removed temporarily
    year: '2023',
    description: 'Estilismo para spot publicitario'
  },
  {
    id: 'multiopticas',
    title: 'MULTIÓPTICAS',
    category: 'publi',
    imageUrl: placeholderImages.publi['multiopticas'],
    linkUrl: '/proyectos/publi/multiopticas',
    // isVideo: false, // ELIMINADO: Video support removed temporarily
    year: '2023',
    description: 'Campaña de moda y accesorios'
  },
  {
    id: 'nesquik',
    title: 'NESQUIK X OMAR MONTES',
    category: 'publi',
    imageUrl: placeholderImages.publi['nesquik'],
    linkUrl: '/proyectos/publi/nesquik-x-omar-montes',
    // isVideo: false, // ELIMINADO: Video support removed temporarily
    year: '2024',
    description: 'Colaboración musical y comercial'
  }
];

// Datos de ejemplo para videoclips
// NOTA: Videos eliminados temporalmente - mantener estructura para futura implementación
export const videoclipsData: CarouselItem[] = [
  {
    id: 'tempo',
    title: 'TEMPO - YOUNG MIKO X MARSHMELLO',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['tempo'],
    linkUrl: '/proyectos/videoclips/tempo-young-miko-marshmello',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2024',
    description: 'Videoclip electrónico urbano'
  },
  {
    id: 'maniaca',
    title: 'MANIACA - ABRAHAM MATEO',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['maniaca'],
    linkUrl: '/proyectos/videoclips/maniaca-abraham-mateo',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2024',
    description: 'Estilismo dinámico y colorido'
  },
  {
    id: 'bellakeo',
    title: 'BELLAKEO - ANITTA Y PESO PLUMA',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['bellakeo'],
    linkUrl: '/proyectos/videoclips/bellakeo-anitta-peso-pluma',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2024',
    description: 'Estilismo para videoclip urbano'
  },
  {
    id: 'tiny-desk',
    title: 'TINY DESK CONCERT',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['tiny-desk'],
    linkUrl: '/proyectos/videoclips/tiny-desk-concert',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2023',
    description: 'Sesión acústica íntima'
  },
  {
    id: 'como-me-gusta',
    title: 'CÓMO ME GUSTA - MARTA SOTO',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['como-me-gusta'],
    linkUrl: '/proyectos/videoclips/como-me-gusta-marta-soto',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2023',
    description: 'Videoclip pop contemporáneo'
  },
  {
    id: 'ron-con-coca',
    title: 'RON CON COCA - OMAR MONTES Y CARIN LEÓN',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['ron-con-coca'],
    linkUrl: '/proyectos/videoclips/ron-con-coca-omar-montes-carin-leon',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2024',
    description: 'Videoclip colaborativo internacional'
  },
  {
    id: 'soltera',
    title: 'SOLTERA - OMAR MONTES Y JOSÉ DE LAS HERAS',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['soltera'],
    linkUrl: '/proyectos/videoclips/soltera-omar-montes-jose-heras',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2024',
    description: 'Estilismo urbano contemporáneo'
  },
  {
    id: 'te-quiero',
    title: 'TE QUIERO - VICCO Y ABRAHAM MATEO',
    category: 'videoclips',
    imageUrl: placeholderImages.videoclips['te-quiero'],
    linkUrl: '/proyectos/videoclips/te-quiero-vicco-abraham-mateo',
    // videoUrl: '', // ELIMINADO: Video files removed temporarily
    year: '2024',
    description: 'Colaboración musical pop'
  }
];

// Datos de ejemplo para colaboraciones
export const colaboracionesData: CarouselItem[] = [
  {
    id: 'tour-cupido-tini',
    title: 'TOUR CUPIDO TINI WIZINK CENTER',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['tour-cupido-tini'],
    linkUrl: '/proyectos/colaboraciones/tour-cupido-tini-wizink',
    year: '2024',
    description: 'Estilismo para tour musical'
  },
  {
    id: 'los-40-2024',
    title: 'LOS 40 MUSIC AWARDS 2024',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['los-40-2024'],
    linkUrl: '/proyectos/colaboraciones/los-40-music-awards-2024',
    year: '2024',
    description: 'Gala de premios musicales'
  },
  {
    id: 'mbfw',
    title: 'MBFW',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['mbfw'],
    linkUrl: '/proyectos/colaboraciones/mbfw',
    year: '2024',
    description: 'Mercedes-Benz Fashion Week'
  },
  {
    id: 'laura-escanes-cielo',
    title: 'ENTRE EL CIELO Y LAS NUBES - LAURA ESCANES',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['laura-escanes-cielo'],
    linkUrl: '/proyectos/colaboraciones/laura-escanes-cielo-nubes',
    year: '2023',
    description: 'Colaboración editorial especial'
  },
  {
    id: 'abraham-mateo-benidorm',
    title: 'ABRAHAM MATEO BENIDORM FEST',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['abraham-mateo-benidorm'],
    linkUrl: '/proyectos/colaboraciones/abraham-mateo-benidorm-fest',
    year: '2024',
    description: 'Estilismo para festival de música'
  },
  {
    id: 'abraham-mateo-eurovision',
    title: 'ABRAHAM MATEO EUROVISIÓN JUNIOR',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['abraham-mateo-eurovision'],
    linkUrl: '/proyectos/colaboraciones/abraham-mateo-eurovision-junior',
    year: '2024',
    description: 'Participación en Eurovisión Junior'
  },
  {
    id: 'aletheia',
    title: 'ALETHEIA',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['aletheia'],
    linkUrl: '/proyectos/colaboraciones/aletheia',
    year: '2024',
    description: 'Colaboración editorial conceptual'
  },
  {
    id: 'violeta-mangrinian',
    title: 'LO TIENES CRUDO - VIOLETA MANGRIÑÁN',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['violeta-mangrinian'],
    linkUrl: '/proyectos/colaboraciones/violeta-mangrinian-lo-tienes-crudo',
    year: '2024',
    description: 'Proyecto de estilismo para influencer'
  },
  {
    id: 'los-40-2023',
    title: 'LOS 40 MUSIC AWARDS 2023',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['los-40-2023'],
    linkUrl: '/proyectos/colaboraciones/los-40-music-awards-2023',
    year: '2023',
    description: 'Gala de premios musicales'
  },
  {
    id: 'manteco',
    title: 'MANTECO',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['manteco'],
    linkUrl: '/proyectos/colaboraciones/manteco',
    year: '2024',
    description: 'Colaboración con marca de moda'
  },
  {
    id: 'premios-idolo-laura',
    title: 'PREMIOS ÍDOLO LAURA ESCANES',
    category: 'colaboraciones',
    imageUrl: placeholderImages.colaboraciones['premios-idolo-laura'],
    linkUrl: '/proyectos/colaboraciones/premios-idolo-laura-escanes',
    year: '2024',
    description: 'Estilismo para premios de moda'
  }
];
